import { useDispatch, useSelector } from "react-redux";
import Modal from "../../UI/Modal";
import { closeAreaFormModal, openAreaViewModal } from "../../../store/reducers/fortalezas/fortalezasPlantel.reducer";
import { useEffect, useState } from "react";
import { updateAreaDesarrolloPlantelThunk, getAreasDesarrolloPlantelThunk, getAreaDesarrolloPlantelByIdThunk } from "../../../store/reducers/fortalezas/fortalezasPlantel.thunks";
import Loader from "../../UI/Loader";
import Alert from "../../UI/Alert";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";

const AreaFormModalPlantel = () => {
  const dispatch = useDispatch();
  const { plantelId } = useParams();
  const { areaFormModalOpen, selectedArea, areaFormLoading, areaFormError, areasPage, areasSearch } = useSelector((state) => state.fortalezasPlantel);

  const [formData, setFormData] = useState({ area: "", descripcion: "" });

  useEffect(() => {
    if (selectedArea) setFormData({ area: selectedArea.area || "", descripcion: selectedArea.descripcion || "" });
  }, [selectedArea, areaFormModalOpen]);

  const handleChange = (e) => setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await dispatch(updateAreaDesarrolloPlantelThunk({ id: selectedArea.id, payload: formData }));
    if (result.meta.requestStatus === "fulfilled") {
      dispatch(getAreasDesarrolloPlantelThunk({ plantelId, page: areasPage, search: areasSearch }));
      toast.success("Área actualizada exitosamente");
      await dispatch(getAreaDesarrolloPlantelByIdThunk(selectedArea.id));
      dispatch(openAreaViewModal());
    }
  };

  return (
    <Modal open={areaFormModalOpen} onClose={() => dispatch(closeAreaFormModal())} title="Editar área" size="lg">
      {areaFormLoading ? <Loader center type="dots" text="Actualizando..." /> : (
        <form onSubmit={handleSubmit}>
          {areaFormError && <Alert message={areaFormError} variant="error" />}
          <div className="mb-3">
            <label className="form-label fw-medium">Área <span className="text-danger">*</span></label>
            <input type="text" className="form-control" name="area" value={formData.area} onChange={handleChange} placeholder="Nombre del área" required />
          </div>
          <div className="mb-3">
            <label className="form-label fw-medium">Descripción</label>
            <textarea className="form-control" name="descripcion" value={formData.descripcion} onChange={handleChange} placeholder="Descripción del área" rows="3" />
          </div>
          <div className="d-flex justify-content-end gap-2">
            <button type="button" className="btn btn-secondary" onClick={() => dispatch(closeAreaFormModal())}>Cancelar</button>
            <button type="submit" className="btn btn-primary">Guardar cambios</button>
          </div>
        </form>
      )}
    </Modal>
  );
};

export default AreaFormModalPlantel;
